import { Main } from "features/Main"; // SEO
import {
  AcfLink,
  Acf_GoogleMap,
  MediaItem,
  MenuItem,
  PostTypeSeo,
  RootQueryToMenuItemConnection,
} from "graphql";
import { SEO } from "features/SEO";

import { Header, Footer } from "components";
import { Oxygen } from "next/font/google";

const sans = Oxygen({
  subsets: ["latin"],
  weight: ["300", "400", "700"],
  variable: "--font-sans",
});
export interface LayoutProps {
  children: React.ReactNode;
  headerMenuItems: RootQueryToMenuItemConnection;
  footerMenuItems: RootQueryToMenuItemConnection;
  title: string;
  description: string;
  logo: MediaItem;
  logoAlt: MediaItem;
  logoWhite: MediaItem;
  seo: PostTypeSeo;
  cta: AcfLink;
  ctaIcon: MediaItem;
  phoneNumber: AcfLink;
  address: Acf_GoogleMap;
  email: AcfLink;
}

const Layout = ({
  children,
  headerMenuItems,
  footerMenuItems,
  cta,
  ctaIcon,
  title,
  description,
  seo,
  logo,
  logoAlt,
  logoWhite,
  phoneNumber,
  address,
  email,
}: LayoutProps) => {
  return (
    <>
      <SEO seo={seo} />
      <div className={`${sans.variable} font-sans`}>
        <Header
          menuItems={headerMenuItems.nodes}
          logo={logo}
          logoAlt={logoAlt}
          cta={cta}
          ctaIcon={ctaIcon}
        />
        <Main className={`main`}>{children}</Main>
        <Footer
          menuItems={footerMenuItems.nodes}
          cta={cta}
          phoneNumber={phoneNumber}
          ctaIcon={ctaIcon}
          address={address}
          email={email}
        />
      </div>
    </>
  );
};

export default Layout;
